<template>       
   <div class="clearfix rounded mx-auto"> 
       <div class="col-md-12 px-0" >
           <div class="d-flex justify-content-center" v-if="ess_allowed == 1">
              <b-col lg="12" class="px-0">
                    <b-button size="lg" @click="punchInorOut"  :disabled="freezeFlag">
                       {{p_i_o_b_label}}
                    </b-button>
                 </b-col>
           </div>
           <l-a-punch-button v-if="mobility == 1" class="mt-2"></l-a-punch-button>
        </div>
   </div>
</template>
<script>
   import moment from 'moment'
   export default{
       mounted() {
           if(this.check_ce == 1)
           {                
               if(this.ce_flg == 1)
                   this.ce = true;
               else
                   this.ce = false;
               
           }   
       },
       props: [ 'flg'],
       components: {},
       data(){ 
           return {
               p_i_o_b_label : 'Loading..',
               freezeFlag: false,
               cookie_btn_click_time: '',
               mobility: 0,
               ess_allowed: 0
           }
           
       },
       methods:{ 
           punchInorOut: function()
           {
              let currentObj = this;
              
              if(this.freezeFlag == false)
              {
                     axios.post(this.$api_url+'/front/employee/attendance/punchinorout' , {
                 }).then(function(response){
                    // inner if 
                       if(response.data){
                          this.$emit('childToParent',response.data); 
                          this.$bvToast.toast('Saved!', {
                                               title: `Punched Successfully`,
                                               variant: 'success',
                                               solid: true
                                            });
                          if(response.data.last_activity == 'in'){
                             this.p_i_o_b_label = 'Punch Out';
                          }
                          else
                          {
                             this.p_i_o_b_label = 'Punch In';
                          }
                          // end of inner if 
                          
                        //   this.getPunchedInOrOut();
                          
                          
                          this.$cookies.set("abc",moment());
                          this.freezeFlag = true;
                          setTimeout( () => {
                             this.freezeFlag = false
                             }, 
                          1000);   
                          
                          location.reload();    
                       }
                             
                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
              }
              
                 
                 
              
           },

         getPunchedInOrOut: function() {
            let currentObj = this;
            axios.get(this.$api_url+'/front/employee/attendance/get-punchedinorout').then(response => {
               // Immediately freeze the button
               currentObj.freezeFlag = true;

               if(response.data.data != null){
                  let activity_logs = response.data.data.activity_log.split(',');
                  let lastLog = activity_logs[activity_logs.length - 1] || "00:00";
                  let today = new Date();
                  let [hh, mm] = lastLog.split(':');
                  let lastPunchTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hh, mm, '00');

                  const now = new Date();
                  const diffMs = now - lastPunchTime;
                  const diffMinutes = Math.floor(diffMs / (1000 * 60));
                  
                  // If last punch was less than 1 minute ago, set 1 minute cooldown
                  // Otherwise, no cooldown needed
                  const cooldownNeeded = diffMinutes < 1;
                  // const cooldownNeeded = false;
                  
                  if (cooldownNeeded) {
                        // Calculate remaining cooldown time in ms
                        const remainingCooldown = (60 * 1000) - diffMs;
                        setTimeout(() => {
                           currentObj.freezeFlag = false;
                        }, remainingCooldown);
                  } else {
                        currentObj.freezeFlag = false;
                  }
               }
               else
               {
                  currentObj.freezeFlag = false;
               }

               currentObj.mobility = response.data.attendance_mobility;
               currentObj.ess_allowed = response.data.can_ess_punch;
               
               if(response.data.last_activity == 'in') {
                     this.p_i_o_b_label = 'Punch Out';
               } else {
                     this.p_i_o_b_label = 'Punch In';
               }
            }).catch(error => { 
               currentObj.serverError(error);
            });
         },
           
        },
       created: function(){
            this.getPunchedInOrOut();
       },
       computed: 
       {
       
          
       }
   }
</script>
